import React from "react";
import {ProductsUIProvider} from "./ProductsUIContext";
import ProductsListCmp from "./ProductsListCmp";

export default function Products() {
    return (
        <ProductsUIProvider>
            <ProductsListCmp/>
        </ProductsUIProvider>
    )
}